import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBelowAvg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 23,
			height: 2,
			transform: "matrix(1 0 0 -1 0 2)",
			fill: "#DF5214"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5 8.26667C14.9426 8.26667 17.7333 11.0574 17.7333 14.5C17.7333 17.9426 14.9426 20.7333 11.5 20.7333C8.05743 20.7333 5.26667 17.9426 5.26667 14.5C5.26667 11.0574 8.05743 8.26667 11.5 8.26667ZM11.5 6C16.1944 6 20 9.80558 20 14.5C20 19.1944 16.1944 23 11.5 23C6.80558 23 3 19.1944 3 14.5C3 9.80558 6.80558 6 11.5 6Z",
			fill: "#DF5214"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0469 15.0947H14.8223V13.8984H12.0469H10.7754H8V15.0947H10.7754H12.0469Z",
			fill: "#DF5214"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.8223 16.0947V12.8984H7V16.0947H15.8223ZM8 15.0947V13.8984H14.8223V15.0947H8Z",
			fill: "#DF5214"
		})
	]
});
export default SvgBelowAvg;
